import React from 'react';
import { Link, NavLink, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboardIcon, FolderIcon, ReceiptIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { Logo } from '../../components/brand/Logo';
import { Seo } from '../../components/Seo';
import { usePortalAuth } from '../../context/PortalAuth';
const NAV = [{
  to: '/portal/dashboard',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  to: '/portal/deliverables',
  label: 'Deliverables',
  icon: FolderIcon
}, {
  to: '/portal/invoices',
  label: 'Invoices',
  icon: ReceiptIcon
}, {
  to: '/portal/account',
  label: 'Account',
  icon: UserIcon
}];
export function PortalLayout() {
  const {
    user,
    signOut
  } = usePortalAuth();
  const navigate = useNavigate();
  if (!user) return <Navigate to="/portal/login" replace data-id="element-1322" data-mp="3m8bd3t2ljrbz" />;
  const onSignOut = () => {
    signOut();
    navigate('/portal/login');
  };
  return <>
      <Seo title="Client portal" description="The Cavalla Solution client portal, where clients see project status, download deliverables and view invoices." path="/portal" noIndex data-id="element-1323" data-mp="1rxo8tu9gy98s" />
      <div className="flex min-h-screen w-full flex-col bg-mist lg:flex-row" data-id="element-1324" data-mp="fyoilidxnwmp">
      <aside className="surface-dark flex shrink-0 flex-col justify-between px-5 py-6 lg:w-72 lg:px-6 lg:py-8" data-id="element-1325" data-mp="b27tolywte8k">
        <div data-id="element-1326" data-mp="63ed2kobt746">
          <Link to="/" aria-label="Cavalla Solution, home" data-id="element-1327" data-mp="63wjub8m73qc">
            <Logo variant="reversed" data-id="element-1328" data-mp="13q3nnix3gs1n" />
          </Link>
          <nav aria-label="Portal" className="mt-10 flex flex-wrap gap-1 lg:flex-col" data-id="element-1329" data-mp="13nr5b4nfcfo2">
            {NAV.map(item => {
              const Icon = item.icon;
              return <NavLink key={item.to} to={item.to} className={({
                isActive
              }) => `flex items-center gap-3 rounded-sm px-3 py-2.5 text-[15px] transition-colors ${isActive ? 'bg-white/12 text-white' : 'text-white/65 hover:bg-white/8 hover:text-white'}`} data-id="element-1330" data-mp="tpup3yfmquj3">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-1331" data-mp="3bvdw3solm5py" />
                  {item.label}
                </NavLink>;
            })}
          </nav>
        </div>

        <div className="mt-10 border-t border-white/12 pt-6" data-id="element-1332" data-mp="31yrdlajqvqr3">
          <p className="text-[15px] text-white" data-id="element-1333" data-mp="36xuhusrwhsy0">{user.name}</p>
          <p className="mt-0.5 text-small text-white/50" data-id="element-1334" data-mp="37070771km5bl">{user.organisationName}</p>
          <button type="button" onClick={onSignOut} className="mt-4 inline-flex items-center gap-2 text-[14px] text-white/65 transition-colors hover:text-gold" data-id="element-1335" data-mp="2t5o57gnyi43b">
            <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-1336" data-mp="2j6ovdurgg2eq" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 px-5 py-8 sm:px-8 lg:px-12 lg:py-12" data-id="element-1337" data-mp="2a8d2tn712ujn">
        <div className="mx-auto w-full max-w-4xl" data-id="element-1338" data-mp="2aa7pb5xy6upu">
          <Outlet data-id="element-1339" data-mp="2e8nad4agxt0m" />
        </div>
      </main>
      </div>
    </>;
}